import _invert from 'lodash/invert';
export const ORDER_MAP = { ascending: 'asc', descending: 'desc' };
export const INVERTED_ORDER_MAP = _invert(ORDER_MAP);
